export default "__VITE_ASSET__BlCimbIJ__"